module.exports = __webpack_public_path__ + "img/10.c2a4d5e9.svg";